import PropTypes from 'prop-types'
import { PureComponent, Component, Fragment } from 'react'
import GifDetail from '../containers/detail'
import { last } from 'lodash'
import { Helmet } from 'react-helmet'
import getHelmetTitle from './helmet-title'
import LocaleSwitch from 'shared/components/locale-switch'
import LocaleBanner from 'shared/components/locale-banner'

class GifDetailFromId extends PureComponent {
    static propTypes = {
        groupId: PropTypes.string,
    }
    state = {}
    componentDidMount() {
        // when we get here via a route,
        // make sure we're scrolled top
        window.scrollTo(0, 0)
    }
    componentDidUpdate({
        match: {
            params: { id: lastSlug },
        },
    }) {
        const {
            match: {
                params: { id: slug },
            },
        } = this.props
        if (slug !== lastSlug) {
            window.scrollTo(0, 0)
        }
    }
    render() {
        const {
            match: {
                params: { id: slug, mode = '' },
            },
            permissions,
            views,
        } = this.props
        if (!slug) {
            throw 'Unable to parse slug from pathname in gif-detail route'
        }
        const gifId = last(slug.split('-'))
        return (
            <GifDetail
                {...{
                    gifId,
                    permissions,
                    views,
                    mode: mode.toLowerCase(),
                }}
            />
        )
    }
}

// Can be incorporated into other routes
class GDWithHelmet extends Component {
    render() {
        const { permissions, pageType, views, gif, search, pagination, location, match } = this.props
        return (
            <Fragment>
                <LocaleBanner />
                <LocaleSwitch />
                <Helmet>
                    <title>{getHelmetTitle(gif, search, pageType)}</title>
                </Helmet>
                <GifDetailFromId
                    {...{
                        gif,
                        pagination,
                        permissions,
                        views,
                        location,
                        match,
                    }}
                />
            </Fragment>
        )
    }
}

export default GDWithHelmet
